import { Helmet } from 'react-helmet-async';
import './landing-variants.css';

const txt = '#3d3d5c';
const dim2 = '#7a7a9e';
const purple = '#7c6cff';
const pink = '#ff9eaa';
const mint = '#6cd4a8';
const lavender = '#c4b5fd';
const card = 'rgba(255,255,255,0.65)';
const clay = '6px 6px 16px rgba(0,0,0,0.06), -3px -3px 10px rgba(255,255,255,0.8), inset 1px 1px 2px rgba(255,255,255,0.6)';
const clayHover = '8px 8px 22px rgba(0,0,0,0.08), -4px -4px 14px rgba(255,255,255,0.9), inset 1px 1px 3px rgba(255,255,255,0.7)';

export default function LandingV9() {
  return (
    <div className="doctif-page" style={{
      fontFamily: 'Urbanist, sans-serif',
      background: 'linear-gradient(135deg, #f0e6ff 0%, #fce4d8 35%, #d5f5e3 70%, #e8ecff 100%)',
      color: txt,
      minHeight: '100vh',
      position: 'relative',
      overflow: 'hidden',
    }}>
      <Helmet><title>doctif — Luminous Ether</title></Helmet>

      {/* Floating blurred orbs */}
      <div aria-hidden className="v9-orb1" style={{
        position: 'fixed', width: 300, height: 300, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(124,108,255,0.15), transparent 70%)',
        top: '10%', left: '5%', filter: 'blur(40px)', pointerEvents: 'none',
      }} />
      <div aria-hidden className="v9-orb2" style={{
        position: 'fixed', width: 350, height: 350, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255,158,170,0.12), transparent 70%)',
        bottom: '20%', right: '8%', filter: 'blur(50px)', pointerEvents: 'none',
      }} />
      <div aria-hidden className="v9-orb3" style={{
        position: 'fixed', width: 250, height: 250, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(108,212,168,0.12), transparent 70%)',
        top: '60%', left: '50%', filter: 'blur(45px)', pointerEvents: 'none',
      }} />

      {/* Header */}
      <header className="doctif-shell" style={{ padding: '28px 0 18px', position: 'relative', zIndex: 1 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontFamily: 'Comfortaa, cursive', fontSize: 28, fontWeight: 700, color: purple }}>doctif</span>
          <nav className="doctif-chip-row">
            {[1,2,3,4,5,6,7,8,9].map(n => (
              <a key={n} className="doctif-chip" href={`/${n}`} style={{
                background: n === 9 ? purple : 'rgba(255,255,255,0.5)',
                color: n === 9 ? '#fff' : dim2,
                backdropFilter: 'blur(10px)',
                fontFamily: 'Comfortaa, cursive', fontSize: 11,
                borderRadius: 20,
                boxShadow: n === 9 ? `0 4px 14px ${purple}44` : '2px 2px 6px rgba(0,0,0,0.04)',
              }}>V{n}</a>
            ))}
          </nav>
        </div>
      </header>

      {/* Hero */}
      <section className="doctif-shell" style={{ padding: '52px 0 40px', position: 'relative', zIndex: 1 }}>
        <div style={{
          display: 'inline-block', background: 'rgba(124,108,255,0.1)',
          borderRadius: 999, padding: '6px 16px', marginBottom: 20,
          backdropFilter: 'blur(8px)',
        }}>
          <span style={{ fontFamily: 'Comfortaa, cursive', fontSize: 11, color: purple, fontWeight: 700 }}>✨ Gestion clinique douce</span>
        </div>

        <h1 style={{
          fontFamily: 'Comfortaa, cursive',
          fontSize: 'clamp(2.2rem, 6vw, 4.5rem)',
          fontWeight: 700, lineHeight: 1.1, marginBottom: 22,
          background: `linear-gradient(135deg, ${purple}, ${pink}, ${purple})`,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
        }}>
          Tout en<br />douceur.
        </h1>

        <p style={{ color: dim2, fontSize: 17, lineHeight: 1.7, maxWidth: 480, marginBottom: 32 }}>
          doctif prend soin de votre flux clinique avec la même attention
          que vous portez à vos patients. Agenda, dossiers, facturation — dans un cocon numérique.
        </p>

        <div style={{ display: 'flex', gap: 14 }}>
          <a href="/accounts/login/" style={{
            fontFamily: 'Comfortaa, cursive', fontSize: 14, fontWeight: 700,
            background: purple, color: '#fff', padding: '14px 26px',
            borderRadius: 28, textDecoration: 'none',
            boxShadow: `0 8px 24px ${purple}44, inset 0 1px 2px rgba(255,255,255,0.3)`,
          }}>Commencer ✨</a>
          <a href="/booking" style={{
            fontFamily: 'Comfortaa, cursive', fontSize: 14, fontWeight: 600,
            background: card, color: txt, padding: '14px 26px',
            borderRadius: 28, textDecoration: 'none',
            backdropFilter: 'blur(10px)', boxShadow: clay,
          }}>Voir la démo</a>
        </div>

        {/* Floating metrics */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 14, marginTop: 36 }}>
          {[
            { v: '240+', l: 'Cabinets actifs', c: purple },
            { v: '61k', l: 'Rendez-vous/mois', c: pink },
            { v: '34%', l: 'Temps gagné', c: mint },
          ].map(m => (
            <div key={m.l} className="v9-gentle" style={{
              background: card, backdropFilter: 'blur(12px)',
              borderRadius: 22, padding: '16px 14px',
              boxShadow: clay, textAlign: 'center',
            }}>
              <div style={{ fontFamily: 'Comfortaa, cursive', fontSize: 28, fontWeight: 700, color: m.c }}>{m.v}</div>
              <div style={{ fontSize: 12, color: dim2, marginTop: 2 }}>{m.l}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Features */}
      <section className="doctif-shell" style={{ padding: '24px 0 60px', position: 'relative', zIndex: 1 }}>
        <div style={{ textAlign: 'center', marginBottom: 44 }}>
          <span style={{
            fontFamily: 'Comfortaa, cursive', fontSize: 11, color: purple,
            background: 'rgba(124,108,255,0.08)', borderRadius: 999,
            padding: '5px 14px', display: 'inline-block', marginBottom: 14,
          }}>Fonctionnalités</span>
          <h2 style={{
            fontFamily: 'Comfortaa, cursive',
            fontSize: 'clamp(1.6rem, 4vw, 2.6rem)', fontWeight: 700, lineHeight: 1.15,
          }}>
            Quatre modules,<br /><span style={{ color: purple }}>zéro stress.</span>
          </h2>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 16 }}>
          {[
            { t: 'Agenda', d: 'Créneaux optimisés avec douceur. Rappels automatiques, sans pression.', e: '📅', co: purple },
            { t: 'Dossiers', d: "Historique patient accessible d'un geste. Notes et radios, toujours là.", e: '📋', co: pink },
            { t: 'Facturation', d: 'Devis et factures générés en douceur. Relances bienveillantes.', e: '💰', co: mint },
            { t: 'Multi-cabinet', d: 'Pilotez vos sites dans un espace unifié et apaisant.', e: '🏥', co: lavender },
          ].map(f => (
            <article key={f.t} style={{
              background: card, backdropFilter: 'blur(12px)',
              borderRadius: 24, padding: '26px 22px', boxShadow: clay,
              transition: 'box-shadow 0.4s ease, transform 0.3s ease',
            }}
              onMouseEnter={e => { e.currentTarget.style.boxShadow = clayHover; e.currentTarget.style.transform = 'translateY(-4px)'; }}
              onMouseLeave={e => { e.currentTarget.style.boxShadow = clay; e.currentTarget.style.transform = 'translateY(0)'; }}
            >
              <div style={{
                width: 48, height: 48, borderRadius: 16,
                background: `${f.co}15`,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 22, marginBottom: 14,
                boxShadow: '3px 3px 8px rgba(0,0,0,0.04), -2px -2px 6px rgba(255,255,255,0.7)',
              }}>{f.e}</div>
              <h3 style={{ fontFamily: 'Comfortaa, cursive', fontSize: 18, fontWeight: 700, marginBottom: 8, color: f.co }}>{f.t}</h3>
              <p style={{ color: dim2, fontSize: 14, lineHeight: 1.6 }}>{f.d}</p>
            </article>
          ))}
        </div>
      </section>

      {/* Dashboard preview */}
      <section className="doctif-shell" style={{ paddingBottom: 60, position: 'relative', zIndex: 1 }}>
        <div style={{
          background: card, backdropFilter: 'blur(16px)',
          borderRadius: 28, padding: 24,
          boxShadow: '8px 8px 24px rgba(0,0,0,0.05), -4px -4px 16px rgba(255,255,255,0.8)',
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18 }}>
            <div>
              <span style={{ fontFamily: 'Comfortaa, cursive', fontSize: 10, color: dim2, textTransform: 'uppercase', letterSpacing: '0.15em' }}>Aperçu du jour</span>
              <h3 style={{ fontFamily: 'Comfortaa, cursive', fontSize: 22, marginTop: 3, color: purple }}>Mardi 25 Mars</h3>
            </div>
            <div style={{ display: 'flex', gap: 6 }}>
              {['Agenda', 'Patients', 'Factures'].map((t, i) => (
                <span key={t} style={{
                  fontFamily: 'Comfortaa, cursive',
                  padding: '5px 12px', borderRadius: 999, fontSize: 11, fontWeight: 700,
                  background: i === 0 ? purple : 'rgba(255,255,255,0.5)',
                  color: i === 0 ? '#fff' : dim2,
                  boxShadow: i === 0 ? `0 3px 10px ${purple}33` : '2px 2px 4px rgba(0,0,0,0.03)',
                }}>{t}</span>
              ))}
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10 }}>
            {[
              { time: '08:30', patient: 'M. Benali', type: 'Contrôle', co: purple },
              { time: '09:15', patient: 'Mme. Idrissi', type: 'Détartrage', co: mint },
              { time: '10:00', patient: 'M. Lahlou', type: 'Prothèse', co: pink },
            ].map(a => (
              <div key={a.time} style={{
                background: 'rgba(255,255,255,0.5)', borderRadius: 18, padding: '14px 12px',
                borderLeft: `3px solid ${a.co}`,
                boxShadow: '3px 3px 8px rgba(0,0,0,0.03), -2px -2px 6px rgba(255,255,255,0.6)',
              }}>
                <div style={{ fontFamily: 'Comfortaa, cursive', color: a.co, fontWeight: 700, fontSize: 12, marginBottom: 4 }}>{a.time}</div>
                <div style={{ fontWeight: 600, fontSize: 14 }}>{a.patient}</div>
                <div style={{ color: dim2, fontSize: 12, marginTop: 2 }}>{a.type}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Workflow */}
      <section className="doctif-shell" style={{ padding: '8px 0 60px', position: 'relative', zIndex: 1 }}>
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <span style={{
            fontFamily: 'Comfortaa, cursive', fontSize: 11, color: purple,
            background: 'rgba(124,108,255,0.08)', borderRadius: 999,
            padding: '5px 14px', display: 'inline-block', marginBottom: 14,
          }}>Comment ça marche</span>
          <h2 style={{ fontFamily: 'Comfortaa, cursive', fontSize: 'clamp(1.4rem, 3.5vw, 2.2rem)', fontWeight: 700 }}>
            Trois étapes,<br /><span style={{ color: purple }}>en toute légèreté.</span>
          </h2>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
          {[
            { s: '1', t: 'Réservation', d: 'Le patient réserve en quelques taps. Confirmation instantanée.', e: '🌸', co: pink },
            { s: '2', t: 'Consultation', d: 'Notes et actes saisis en douceur, directement au fauteuil.', e: '🌿', co: mint },
            { s: '3', t: 'Suivi', d: 'Facture et relance envoyées automatiquement. Tout est fluide.', e: '🦋', co: purple },
          ].map(w => (
            <div key={w.s} style={{
              background: card, backdropFilter: 'blur(12px)',
              borderRadius: 24, padding: '28px 20px', textAlign: 'center',
              boxShadow: clay,
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = clayHover; }}
              onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = clay; }}
            >
              <div style={{ fontSize: 36, marginBottom: 12 }}>{w.e}</div>
              <div style={{ fontFamily: 'Comfortaa, cursive', fontSize: 11, color: w.co, marginBottom: 8, fontWeight: 700 }}>Étape {w.s}</div>
              <h3 style={{ fontFamily: 'Comfortaa, cursive', fontSize: 18, fontWeight: 700, marginBottom: 10 }}>{w.t}</h3>
              <p style={{ color: dim2, fontSize: 13, lineHeight: 1.6 }}>{w.d}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Testimonials */}
      <section className="doctif-shell" style={{ padding: '8px 0 56px', position: 'relative', zIndex: 1 }}>
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <h2 style={{ fontFamily: 'Comfortaa, cursive', fontSize: 'clamp(1.4rem, 3.5vw, 2.2rem)', fontWeight: 700 }}>
            Des praticiens <span style={{ color: pink }}>heureux</span> 💜
          </h2>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          {[
            { q: "L'interface est d'une douceur incroyable. Mes assistantes l'adorent.", n: 'Dr. Khalil', cl: 'Al Madina — Casablanca', co: purple },
            { q: "Simple, beau, efficace. C'est exactement ce dont on avait besoin.", n: 'Dr. Brahmi', cl: 'Corbei — Oujda', co: pink },
          ].map(t => (
            <div key={t.n} style={{
              background: card, backdropFilter: 'blur(12px)',
              borderRadius: 24, padding: '24px 20px', boxShadow: clay,
            }}>
              <div style={{ color: '#fbbf24', fontSize: 16, letterSpacing: 2, marginBottom: 10 }}>★★★★★</div>
              <blockquote style={{
                fontFamily: 'Comfortaa, cursive', fontSize: 16, fontWeight: 500,
                lineHeight: 1.5, margin: '0 0 16px', fontStyle: 'italic',
              }}>"{t.q}"</blockquote>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div style={{
                  width: 36, height: 36, borderRadius: '50%',
                  background: `linear-gradient(135deg, ${t.co}, ${t.co}88)`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 12, fontWeight: 800, color: '#fff',
                  boxShadow: `0 3px 10px ${t.co}33`,
                }}>{t.n.split(' ').map(w => w[0]).join('')}</div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 13 }}>{t.n}</div>
                  <div style={{ color: dim2, fontSize: 11 }}>{t.cl}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Trust */}
      <div style={{ position: 'relative', zIndex: 1 }}>
        <div style={{ background: 'rgba(255,255,255,0.3)', backdropFilter: 'blur(16px)' }}>
          <div className="doctif-shell" style={{
            padding: '32px 0', display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)', gap: 14, textAlign: 'center',
          }}>
            {[
              { e: '🔒', t: 'Chiffré', d: 'AES-256' },
              { e: '🇲🇦', t: 'Hébergé ici', d: 'Maroc' },
              { e: '⚡', t: 'Temps réel', d: '< 1s' },
              { e: '🎧', t: 'Support', d: '< 2h' },
            ].map(t => (
              <div key={t.t}>
                <div style={{ fontSize: 24, marginBottom: 6 }}>{t.e}</div>
                <div style={{ fontFamily: 'Comfortaa, cursive', fontWeight: 700, fontSize: 13, marginBottom: 2 }}>{t.t}</div>
                <div style={{ color: dim2, fontSize: 11 }}>{t.d}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA */}
      <section className="doctif-shell" style={{ padding: '60px 0', textAlign: 'center', position: 'relative', zIndex: 1 }}>
        <h2 style={{
          fontFamily: 'Comfortaa, cursive',
          fontSize: 'clamp(1.8rem, 5vw, 3rem)', fontWeight: 700, marginBottom: 14,
          background: `linear-gradient(135deg, ${purple}, ${pink})`,
          WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
        }}>
          Prêt pour la<br />douceur ?
        </h2>
        <p style={{ color: dim2, maxWidth: 380, margin: '0 auto 28px', fontSize: 14, lineHeight: 1.65 }}>
          Rejoignez les praticiens qui ont choisi le calme. Sans engagement.
        </p>
        <div style={{ display: 'flex', gap: 14, justifyContent: 'center' }}>
          <a href="/accounts/login/" style={{
            fontFamily: 'Comfortaa, cursive', fontSize: 15, fontWeight: 700,
            background: purple, color: '#fff', padding: '15px 30px',
            borderRadius: 28, textDecoration: 'none',
            boxShadow: `0 8px 28px ${purple}44, inset 0 1px 3px rgba(255,255,255,0.3)`,
          }}>Commencer avec doctif ✨</a>
          <a href="/booking" style={{
            fontFamily: 'Comfortaa, cursive', fontSize: 15, fontWeight: 600,
            background: card, color: txt, padding: '15px 26px',
            borderRadius: 28, textDecoration: 'none',
            backdropFilter: 'blur(10px)', boxShadow: clay,
          }}>Voir la démo</a>
        </div>
      </section>

      {/* Footer */}
      <footer style={{ position: 'relative', zIndex: 1 }}>
        <div style={{ background: 'rgba(255,255,255,0.2)', backdropFilter: 'blur(10px)' }}>
          <div className="doctif-shell" style={{ padding: '22px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <span style={{ fontFamily: 'Comfortaa, cursive', fontSize: 18, color: dim2 }}>doctif</span>
              <span style={{ color: '#d1d1e0' }}>|</span>
              <span style={{ color: dim2, fontSize: 11 }}>Luminous Ether — V09</span>
            </div>
            <div style={{ display: 'flex', gap: 20 }}>
              {['Confidentialité', 'CGU', 'Contact'].map(l => (
                <a key={l} href="#" style={{ color: dim2, fontSize: 11, textDecoration: 'none', fontFamily: 'Comfortaa, cursive' }}
                  onMouseEnter={e => (e.currentTarget.style.color = purple)}
                  onMouseLeave={e => (e.currentTarget.style.color = dim2)}
                >{l}</a>
              ))}
            </div>
          </div>
        </div>
      </footer>

      <style>{`
        .v9-orb1 { animation: v9f1 8s ease-in-out infinite; }
        .v9-orb2 { animation: v9f2 10s ease-in-out infinite; }
        .v9-orb3 { animation: v9f3 7s ease-in-out infinite; }
        .v9-gentle { animation: v9g 4s ease-in-out infinite; }
        @keyframes v9f1 { 0%,100% { transform: translate(0,0); } 50% { transform: translate(30px,-20px); } }
        @keyframes v9f2 { 0%,100% { transform: translate(0,0); } 50% { transform: translate(-25px,15px); } }
        @keyframes v9f3 { 0%,100% { transform: translate(0,0); } 50% { transform: translate(15px,-25px); } }
        @keyframes v9g { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-3px); } }
      `}</style>
    </div>
  );
}
